//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ElLottie from '@/components/UI/el-lottie'

export default {
  name: 'FormatSection',
  components: {
    ElLottie,
  },
  data() {
    return {
      formatAnimationFirst: {
        container: '.format__el-img',
        renderer: 'svg',
        loop: true,
        autoplay: true,
        animationData: `/${this.$route.path.split('/').pop()}/format-1.json`,
      },
    }
  },
}
